/**
 * Site-wide configuration and constants.
 * Update this file to personalise the portfolio.
 */

const config = {
  owner: {
    name: "Xuchen Sun",
    role: "Full Stack Software Engineer",
    // Update with your real LinkedIn profile URL
    linkedinUrl: "https://linkedin.com/in/xuchensun",
  },

  github: {
    username: "XuchenSun",
    profileUrl: "https://github.com/XuchenSun",
  },

  // Preloader display duration in milliseconds
  preloaderDuration: 1200,
};

export default config;
